const Events = () =>
  import(
    /* webpackChunkName: "message-events" */ '@/pages/message/events/index.vue'
  )
const EditEvents = () =>
  import(
    /* webpackChunkName: "message-events" */ '@/pages/message/events/edit.vue'
  )

export default {
  path: 'events',
  meta: {
    label: 'events',
    auth: 'event'
  },
  component: {
    name: 'Events',
    render(c) {
      return c('router-view')
    }
  },
  children: [
    {
      name: 'MessageEvent',
      path: '',
      meta: {
        label: 'report',
        auth: 'report'
      },
      component: Events
    },
    {
      name: 'MessageEditEvent',
      path: 'edit/:id',
      meta: {
        label: 'edit',
        auth: 'update'
      },
      component: EditEvents,
      props: true
    }
  ]
}
